import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IPopUpWindowConfig } from '../../typing/confirm-messages.interface';

@Component({
    selector: 'app-messages',
    standalone: true,
    templateUrl: './message.component.html',
    imports: [MatDialogModule, MatButtonModule, MatIconModule],
    styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
    protected config: IPopUpWindowConfig = inject(MAT_DIALOG_DATA);
    protected dialogRef = inject(MatDialogRef<MessageComponent>);
}
